import React, { useState, useEffect } from "react";
import "./discussion.css";
import { Outlet } from "react-router-dom";
import ChannelItem from "../components/channel-item/ChannelItem";
import { IoNotificationsOutline } from "react-icons/io5";
import { PiChatsCircleBold } from "react-icons/pi";
import { useSelector } from "react-redux";
import Loading from "../../../ui/atoms/loading/Loading";
import { wait } from "../../../core/utils/helpers";

const Discussion = () => {
  const [isLoading, setIsLoading] = useState(true);

  const initConnectedUser = useSelector(
    (state) => state.setInitConf.initConnectedUser,
  );

  const sys_role = initConnectedUser?.sys_role;

  useEffect(() => {
    const fetchData = async () => {
      await wait(1500);

      setIsLoading(false);
    };

    fetchData();
  }, []);

  return (
    <div className="discussions">
      {isLoading ? (
        <Loading type={"type-2"} />
      ) : (
        <React.Fragment>
          <div className="d-channels">
            <ChannelItem
              Icon={IoNotificationsOutline}
              title={"Notifications"}
              to={`/${sys_role}/discussions`}
              is_exact={true}
              count={0}
            />
            <ChannelItem
              Icon={PiChatsCircleBold}
              title={"Messages"}
              to={`/${sys_role}/discussions/messages`}
              is_exact={false}
              count={0}
            />
          </div>
          <div className="d-box">
            <Outlet />
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default Discussion;
